export type EpcInvoiceReference =
  | string
  | {
      _id?: string;
      id?: string;
      invoiceId?: string;
      invoiceNumber?: string;
      createdAt?: Date | string;
    };

export const getEpcInvoiceId = (reference: unknown): string => {
  if (typeof reference === "string") return reference;
  if (!reference || typeof reference !== "object") return "";

  const record = reference as Record<string, unknown>;
  for (const key of ["_id", "invoiceId", "id"]) {
    const invoiceId = record[key];
    if (typeof invoiceId === "string" && invoiceId) return invoiceId;
  }
  return "";
};

export const getEpcInvoiceIds = (references: unknown): string[] => {
  const records = Array.isArray(references)
    ? references
    : references
      ? [references]
      : [];
  return records.map(getEpcInvoiceId).filter(Boolean);
};
